type Validatable=HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement;

function message(field:Validatable){
 const validity=field.validity;
 if(validity.valueMissing)return 'Preencha este campo.';
 if(validity.typeMismatch)return field instanceof HTMLInputElement&&field.type==='email'?'Introduza um e-mail válido.':'Introduza um valor válido.';
 if(validity.patternMismatch)return 'Verifique o formato indicado para este campo.';
 if(validity.tooShort)return 'Introduza mais caracteres.';
 if(validity.tooLong)return 'O texto é demasiado comprido.';
 if(validity.rangeUnderflow)return `Introduza um valor igual ou superior a ${field instanceof HTMLInputElement?field.min:''}.`;
 if(validity.rangeOverflow)return `Introduza um valor igual ou inferior a ${field instanceof HTMLInputElement?field.max:''}.`;
 if(validity.stepMismatch||validity.badInput)return 'Introduza um valor válido.';
 return 'Verifique este campo.';
}

/** Native constraint bubbles follow the browser locale, not the page lang. */
export function installPortugueseValidation(){
 const translated=new WeakSet<Validatable>();
 const onInvalid=(event:Event)=>{const field=event.target;if(!(field instanceof HTMLInputElement||field instanceof HTMLSelectElement||field instanceof HTMLTextAreaElement)||document.documentElement.lang!=='pt')return;
  if(field.validity.customError&&!translated.has(field))return;
  if(translated.has(field))field.setCustomValidity('');
  field.setCustomValidity(message(field));translated.add(field);
 };
 const clear=(event:Event)=>{const field=event.target;if(!(field instanceof HTMLInputElement||field instanceof HTMLSelectElement||field instanceof HTMLTextAreaElement)||!translated.has(field))return;field.setCustomValidity('');translated.delete(field);};
 document.addEventListener('invalid',onInvalid,true);
 document.addEventListener('input',clear,true);
 document.addEventListener('change',clear,true);
 return()=>{document.removeEventListener('invalid',onInvalid,true);document.removeEventListener('input',clear,true);document.removeEventListener('change',clear,true);};
}
